import { memo } from 'react';
import { clsx } from 'clsx';
import { ThirdPartSelectors } from '@headless-workspace/config';
import { GlowTag, GlowTagExtended, PropsWithClassName } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import { FlagValue } from '../../types';

type ProductVisualFlagsProps = PropsWithClassName & {
    flags?: FlagValue[];
};

export const ProductVisualFlags: ComponentMemo<ProductVisualFlagsProps> = memo(({ flags, className }) => {
    return (
        <ul className={clsx(className, 'flex gap-0.5')}>
            <li className={clsx(ThirdPartSelectors.PurchaseInAppFlagClass)} />
            {flags?.map((flag) => (
                <li key={flag.id}>
                    {flag.endDate ? (
                        <GlowTagExtended
                            label={flag.label}
                            extendedLabel={flag.endDate}
                            size={'medium'}
                            color={'primaryBlack'}
                        />
                    ) : (
                        <GlowTag label={flag.label} size={'medium'} color={'primaryBlack'} />
                    )}
                </li>
            ))}
        </ul>
    );
});

ProductVisualFlags.displayName = 'ProductVisualFlags';
